import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import type PurchasesConfirmationsShow from "@travily/types/pages/PurchasesConfirmationsShow";
import type { ReactNode } from "react";
import { PurchaseSuccessModal } from "@/components/PurchaseSuccess";
import { RoutedModal } from "@/components/RoutedModal";
import { PurchaseConfirmationView } from "./confirmation.view";

// Rendered as a modal over the listing page: paid buyers land here on the
// Stripe success redirect (cold load opens the modal over the product page).
const PurchaseConfirmationPage = (props: PurchasesConfirmationsShow) => (
  <PurchaseConfirmationView>
    <Head title={t("web.purchases.confirmations.show.meta_title")} />
    <RoutedModal size="sm">{({ close }) => <PurchaseSuccessModal {...props} onClose={close} />}</RoutedModal>
  </PurchaseConfirmationView>
);

PurchaseConfirmationPage.layout = (page: ReactNode) => page;

export default PurchaseConfirmationPage;
